import request from '@/utils/request'

export function updateRunForItCfg(data) {
  return request({
    url: 'api/v1/run-for-it/updateCfg',
    method: 'post',
    data: data
  })
}

export function getRunForItCfgList(data) {
  return request({
    url: 'api/v1/run-for-it/getList',
    method: 'post',
    data: data
  })
}

export function delRunForItCfgList(data) {
  return request({
    url: 'api/v1/run-for-it/deleteCfg',
    method: 'delete',
    data: data
  })
}

export function exportRunForItCfg() {
  return request({
    url: 'api/v1/run-for-it/export',
    method: 'post'
  })
}

export function importRunForItCfg(data) {
  return request({
    url: 'api/v1/run-for-it/import',
    method: 'post',
    data: data
  })
}

export function getParkourList(data) {
  return request({
    url: 'api/v1/run-for-it-v2/list',
    method: 'post',
    data: data
  })
}

export function exportParkourCfg(data) {
  return request({
    url: 'api/v1/run-for-it-v2/export',
    method: 'post',
    data: data
  })
}

export function importParkourCfg(data) {
  return request({
    url: 'api/v1/run-for-it-v2/import',
    method: 'post',
    data: data
  })
}

export function runFotItBaseConf(data) {
  return request({
    url: 'api/v1/run-for-it-v2/base',
    method: 'post',
    data: data
  })
}

export function saveRunFotItBaseConf(data) {
  return request({
    url: 'api/v1/run-for-it-v2/saveBase',
    method: 'post',
    data: data
  })
}

export function delRunFotItConf(data) {
  return request({
    url: 'api/v1/run-for-it-v2/delete',
    method: 'post',
    data: data
  })
}
